import React from "react";
import LearningCard from "../../components/LearningCard";
import Slider from "react-slick";
import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import "./styles.scss";
import CourseCard from "../CourseCard";

export default function CourseSlider(props) {
  const { dataCourse } = props;
  let settings = {
    dots: false,
    lazyLoad: true,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    initialSlide: 0,
    prevArrow: (
      <button type="button" className="slick-prev">
        <FaChevronLeft />
      </button>
    ),
    nextArrow: (
      <button type="button" className="slick-next">
        <FaChevronRight />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    dataCourse && (
      <>
        <div className="slider-content">
          <div className="slider-container">
            <Slider {...settings}>
              {dataCourse.map((data, index) => {
                return (
                  <div key={index}>
                    <LearningCard key={index} course={data} />
                    {/* <CourseCard key={index} course={data} /> */}
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </>
    )
  );
}
